import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { clickStreamUser } from "../../../utils/AppUtils";
import { homePageMsg, homePageShowMsg } from "../../../redux/home/actions";
import { getEnrollBrokerSessionClear, hostSessionClear, joinSessionClear } from "../../../redux/events/actions";
import _ from "lodash";
import { addToCartClear } from "../../../redux/product/actions";
import { useNavigate } from "react-router-dom";

const CalendarLogicComponent = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authBroker = useSelector(state => state.auth.authBroker)
    const userRole = useSelector(state => state.user.role)

    const enrollBrokerSession = useSelector((state) => state.events.enrollBrokerSession);
    const joinSessionData = useSelector(state => state.events.joinSession);
    const addToCartRes = useSelector(state => state.product.addToCart)
    const hostSessionInfo = useSelector(state => state.events.hostSession);
    const attendence = useSelector(state => state.events.sessionAttendenceMarked)

    useEffect(() => {
        console.log("enrolled FROM Home page Calendar", enrollBrokerSession);
        if (!_.isEmpty(enrollBrokerSession)) {
            if (enrollBrokerSession?.status === "success") {
                let data = enrollBrokerSession.payload.payload;
                dispatch(homePageMsg(enrollBrokerSession?.payload?.message))
                clickStreamUser("session-registered-successfull", {
                    // event_id: event_id,
                    session_id: data.session_id,
                    user_id: authBroker?.payload?.user?.user_id,
                    message: enrollBrokerSession?.payload?.message,
                });
            } else if (enrollBrokerSession?.status === "error") {
                dispatch(homePageMsg(enrollBrokerSession?.error?.message))
            }
            dispatch(homePageShowMsg(true))
            setTimeout(() => {
                dispatch(homePageShowMsg(false))
            }, 5000)
            dispatch(getEnrollBrokerSessionClear());
        }
    }, [enrollBrokerSession]);

    useEffect(() => {
        // console.log('joinSessionData', joinSessionData);
        if (!_.isEmpty(joinSessionData)) {
            if (joinSessionData.status === 'success') {
                if (!_.isEmpty(joinSessionData.payload.payload)) {
                    const sessionData = joinSessionData.payload.payload;
                    if (sessionData.join_url) {
                        window.open(sessionData.join_url, '_blank');
                    } else {
                        if (userRole === 'realtor') {
                            dispatch(homePageMsg('Error joining session, please contact your manager'))
                        } else if (userRole === 'manager') {
                            dispatch(homePageMsg('Error joining session, please contact your admin'))
                        } else {
                            dispatch(homePageMsg('Error joining session, please contact support'))
                        }
                    }
                } else {
                    dispatch(homePageMsg(joinSessionData?.error?.message))
                }
            } else {
                // console.log(joinSessionData.error.message)
                dispatch(homePageMsg(joinSessionData?.error?.message))
            }
            dispatch(homePageShowMsg(true))
            setTimeout(() => {
                dispatch(homePageShowMsg(false))
            }, 5000)
            dispatch(joinSessionClear())
        }
    }, [joinSessionData])

    useEffect(() => {
        if (!_.isEmpty(hostSessionInfo)) {
            if (hostSessionInfo.status === "success") {
                if (!_.isEmpty(hostSessionInfo.payload.payload)) {
                    // console.log('hostSessionInfo', hostSessionInfo.payload.payload);
                    const hostData = hostSessionInfo.payload.payload.data;
                    if (hostData.start_url) {
                        window.open(hostData.start_url, '_blank');
                    } else {
                        if (userRole === 'realtor') {
                            dispatch(homePageMsg('Server Error, please contact your manager'))
                        } else if (userRole === 'manager') {
                            dispatch(homePageMsg('Server Error, please contact your admin'))
                        } else {
                            dispatch(homePageMsg('Server Error, please contact support'))
                        }
                    }
                } else {
                    // console.log(hostSessionInfo.error.message)
                    dispatch(homePageMsg(hostSessionInfo?.error?.message))
                }
            } else {
                dispatch(homePageMsg(hostSessionInfo?.error?.message))
            }
            dispatch(homePageShowMsg(true))
            setTimeout(() => {
                dispatch(homePageShowMsg(false))
            }, 5000)
            dispatch(hostSessionClear())
        }
    }, [hostSessionInfo])

    useEffect(() => {
        // setShowModalMsg(addToCartRes?.payload.message)
        if (Object.keys(addToCartRes).length !== 0) {
            // navigate('/cart')
            // dispatch(addToCartClear())
        }
    }, [addToCartRes])

    return (
        <></>
    )
}

export default CalendarLogicComponent